import DF from 'DisplayFramework';
import Dashboard from './Dashboard';
import GetLabel from 'DisplayFramework/components/GetLabel';
import LimitCharged from './LimitCharged';
import React from 'react';
import TabPane from 'antd/es/tabs/TabPane';
import { Tabs } from 'antd';
import { useForm } from 'antd/lib/form/Form';

export type ConfigTabsProps = {};

const GlobalVision = ({}: ConfigTabsProps) => {
  const [form] = useForm();

  return (
    // <DF.Provider pagcode="configsfs">
    <DF.Provider pagcode="visionGlobal">

      <Tabs className=" tabs-border-top">
        <TabPane tab={<GetLabel label="dashbord" />} key="1"><Dashboard /></TabPane>
        <TabPane tab={<GetLabel label="limitConsumed" />} key="2"></TabPane>
        <TabPane tab={<GetLabel label="limitCharged" />} key="3"></TabPane>
      </Tabs>
    </DF.Provider>
  );
};

export default GlobalVision;